export namespace FeaturesActions {
  export class SetApplicationFeatures {
    static readonly type = '[DebrisFlow Features] SetApplicationFeatures';

    static readonly success = 'Application features have been set.';
    static readonly error = 'An error occurred setting application features.';
  }
}
